export default [{
  path: '/onboarding',
  component: () => import('@/feature/onboarding/views/OnboardingTemplate.vue'),
  name: 'onboarding-main',
  children: [{
    path: '/onboarding/proximos-passos',
    name: 'onboarding-next-steps',
    component: () => import('@/feature/onboarding/views/OnboardingNextSteps.vue'),
  }, {
    path: '/onboarding/faltando',
    name: 'onboarding-missing-steps',
    component: () => import('@/feature/onboarding/views/OnboardingMissingSteps.vue'),
  }, {
    path: '/onboarding/frente',
    name: 'onboarding-frontdoc-step',
    component: () => import('@/feature/onboarding/views/OnboardingFrontdoc.vue'),
  }, {
    path: '/onboarding/frente/camera',
    name: 'onboarding-frontdoc-camera',
    component: () => import('@/feature/onboarding/views/OnboardingFrontdocCamera.vue'),
  }, {
    path: '/onboarding/frente/analisando',
    name: 'onboarding-frontdoc-loading',
    props: {
      successText: 'Frente do documento enviada',
      onSucessGoTo: 'onboarding-backdoc-step',
      onErrorGoTo: 'onboarding-error',
      onRetryGoTo: 'onboarding-frontdoc-camera',
    },
    component: () => import('@/feature/onboarding/views/OnboardingLoading.vue'),
  }, {
    path: '/onboarding/verso',
    name: 'onboarding-backdoc-step',
    component: () => import('@/feature/onboarding/views/OnboardingBackdoc.vue'),
  }, {
    path: '/onboarding/verso/camera',
    name: 'onboarding-backdoc-camera',
    component: () => import('@/feature/onboarding/views/OnboardingBackdocCamera.vue'),
  }, {
    path: '/onboarding/verso/analisando',
    name: 'onboarding-backdoc-loading',
    props: {
      successText: 'Verso do documento enviado',
      onSucessGoTo: 'onboarding-selfie-step',
      onErrorGoTo: 'onboarding-error',
      onRetryGoTo: 'onboarding-backdoc-camera',
    },
    component: () => import('@/feature/onboarding/views/OnboardingLoading.vue'),
  }, {
    path: '/onboarding/selfie',
    name: 'onboarding-selfie-step',
    component: () => import('@/feature/onboarding/views/OnboardingSelfie.vue'),
  }, {
    path: '/onboarding/selfie/camera',
    name: 'onboarding-selfie-faceTec-camera',
    component: () => import('@/feature/onboarding/views/OnboardingSelfieFaceTecCamera.vue'),
  },
  {
    path: '/onboarding/selfie/parcelex/camera',
    name: 'onboarding-selfie-parcelex-camera',
    component: () => import('@/feature/onboarding/views/OnboardingSelfieCamera.vue'),
  },
  {
    path: '/onboarding/selfie/parcelex/analisando',
    name: 'onboarding-selfie-parcelex-loading',
    props: {
      onErrorGoTo: 'onboarding-error',
      onRetryGoTo: 'onboarding-selfie-parcelex-error',
    },
    component: () => import('@/feature/onboarding/views/OnboardingLoading.vue'),
  }, {
    path: '/onboarding/selfie/parcelex/erro',
    name: 'onboarding-selfie-parcelex-error',
    component: () => import('@/feature/onboarding/views/OnboardingSelfieError.vue'),
  },
  {
    path: '/onboarding/camera-error/android',
    name: 'onboarding-camera-error-android',
    component: () => import('@/feature/onboarding/views/OnboardingCameraErrorAndroid.vue'),
  }, {
    path: '/onboarding/camera-error/ios',
    name: 'onboarding-camera-error-ios',
    component: () => import('@/feature/onboarding/views/OnboardingCameraErrorIos.vue'),
  }, {
    path: '/onboarding/seguro',
    name: 'onboarding-insurance',
    component: () => import('@/feature/onboarding/views/OnboardingInsurance.vue'),
  }, {
    path: '/onboarding/assinatura',
    name: 'onboarding-signature',
    component: () => import('@/feature/onboarding/views/OnboardingSignature.vue'),
  }, {
    path: '/onboarding/contrato',
    name: 'onboarding-signature-contract-view',
    component: () => import('@/feature/onboarding/views/OnboardingContractView.vue'),
  }, {
    path: '/onboarding/completo',
    name: 'onboarding-complete',
    component: () => import('@/feature/onboarding/views/OnboardingComplete.vue'),
  }, {
    path: '/onboarding/aprovado',
    name: 'onboarding-approved',
    component: () => import('@/feature/onboarding/views/OnboardingApproved.vue'),
  }, {
    path: '/onboarding/negado',
    name: 'onboarding-denied',
    component: () => import('@/feature/onboarding/views/OnboardingDenied.vue'),
  }, {
    path: '/onboarding/erro',
    name: 'onboarding-error',
    component: () => import('@/feature/onboarding/views/OnboardingError.vue'),
  }, {
    path: '/onboarding/selfie/erro',
    name: 'onboarding-facetec-error',
    component: () => import('@/feature/onboarding/views/OnboardingFacetecError.vue'),
  }, {
    path: '/onboarding/tente-novamente',
    name: 'onboarding-error-generic',
    component: () => import('@/feature/onboarding/views/OnboardingErrorGeneric.vue'),
  }],
}];
